export enum WorkScheduleFrequency {
    WEEK_IN_ADVANCE = 'A week in advance',
    BIWEEKLY = 'Biweekly',
    MONTHLY = 'Monthly',
    OTHER = 'Other'
}